import { render, staticRenderFns } from "./Competition.vue?vue&type=template&id=3db4f0fc&scoped=true&"
import script from "./Competition.vue?vue&type=script&lang=ts&"
export * from "./Competition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db4f0fc",
  null
  
)

export default component.exports